export default __webpack_public_path__ + "static/char-thumb-35-a5d219bcdaa040e6daf08140a28256dc.png";